var map = {
	"./gallery-runes_00.jpg": 2311,
	"./gallery-runes_01.jpg": 2312,
	"./gallery-runes_02.jpg": 2313,
	"./gallery_00.jpg": 2314,
	"./gallery_01.jpg": 2315,
	"./gallery_02.jpg": 2316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2310;